import { KW } from './theme'

const CheckIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={KW.teal}
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 6L9 17l-5-5" />
  </svg>
)

interface Props {
  title: string
  description?: string
  selected?: boolean
  dimmed?: boolean
  disabled?: boolean
  onClick?: () => void
}

/**
 * Full-width selectable card — clarification options today; any future
 * pick-one-of-N flow (action choices, entity disambiguation) should reuse it.
 */
const OptionCard = ({
  title,
  description,
  selected,
  dimmed,
  disabled,
  onClick,
}: Props) => (
  <button
    type="button"
    disabled={disabled}
    aria-pressed={!!selected}
    onClick={onClick}
    className="flex w-full items-center gap-[10px] rounded-[10px] px-3 py-[10px] text-left"
    style={{
      fontFamily: 'inherit',
      border: `1px solid ${selected ? KW.teal : KW.line2}`,
      background: selected ? KW.soft : disabled ? '#fafbfc' : '#fff',
      opacity: dimmed ? 0.5 : 1,
      cursor: disabled ? 'default' : 'pointer',
    }}
  >
    <div className="min-w-0 flex-1">
      <div className="text-[13.5px] font-bold" style={{ color: KW.ink }}>
        {title}
      </div>
      {description && (
        <div className="text-[11.5px]" style={{ color: KW.muted }}>
          {description}
        </div>
      )}
    </div>
    {selected ? (
      <CheckIcon />
    ) : (
      !disabled && (
        <span className="text-xs font-bold" style={{ color: KW.teal500 }}>
          Select
        </span>
      )
    )}
  </button>
)

export default OptionCard
